/* eslint-disable react/prop-types */
import React, { ReactChild, useState } from "react";
import { FormControl } from "react-bootstrap";
import { MESSAGE_PLACEHOLDER_SELECT_MENU } from "../data/message-placeholders";

interface IProps {
  children: ReactChild;
  style: React.CSSProperties;
  className: string;
  "aria-labelledby": string;
}

const SelectMenu = React.forwardRef<HTMLDivElement,IProps>(
  (
    { children, style, className, "aria-labelledby": labeledBy }: IProps,
    ref
  ) => {
    const [value, setValue] = useState("");

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
      };

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <FormControl
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder={MESSAGE_PLACEHOLDER_SELECT_MENU}
          onChange={handleOnChange}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter((child) => {
            if (React.isValidElement<{ children: string }>(child)) {
              return (
                !value ||
                child.props.children.toLowerCase().includes(value.toLowerCase()) //child.props.children.toLowerCase().startsWith(value)
              );
            }
            return false;
          })}
        </ul>
      </div>
    );
  }
);

SelectMenu.displayName = "SelectMenu";
export default SelectMenu;
